import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Wind, Heart, Compass, HeartPulse, TrendingUp } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Oferta1la1Benefits() {
  const benefits = [{
    icon: Eye,
    title: 'Conștientizezi ce te ținea pe loc',
    desc: 'Vezi cu claritate credința exactă care îți modelase deciziile. Nu mai e abstract. Ai un răspuns concret.'
  }, {
    icon: Wind,
    title: 'Eliberezi straturi vechi de emoții',
    desc: 'Resentimente, frici, tristețe — toate cele cărate ani de zile se eliberează în siguranță, fără să le retrăiești.'
  }, {
    icon: Heart,
    title: 'Te reconectezi la tine',
    desc: 'Multă pace interioară, mai multă claritate, sentimentul că ești "acasă" în propriul corp și propria viață.'
  }, {
    icon: Compass,
    title: 'Primești direcție',
    desc: 'Pleci din ședință cu pași concreți. Știi ce să faci diferit, ce să observi, cum să integrezi schimbarea.'
  }, {
    icon: HeartPulse,
    title: 'Schimbări reale în viața de zi cu zi',
    desc: 'Relațiile devin mai armonioase, banii încep să curgă mai natural, sănătatea se îmbunătățește. Pe măsură ce subconștientul se aliniază.'
  }, {
    icon: TrendingUp,
    title: 'Procesul se accelerează',
    desc: 'Ce ai citit ani de zile prin cărți și cursuri se integrează mult mai rapid prin lucru direct cu rădăcinile.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1685">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1686">
        <SectionHeading title="Ce se schimbă după ședințele 1 la 1" data-id="element-1687" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1688">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-1689">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-1690">
                  <Icon className="w-8 h-8" data-id="element-1691" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-1692">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-1693">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1694">
          <CTAButton data-id="element-1695" />
        </motion.div>
      </div>
    </section>;
}